import { getUser } from "$lib/userstorage/usersotrage"
import { handleAuthenticatedRequest, jsonOrThrow } from "../errores/erroresback"
import { queryClient, cacheRestored } from "$lib/query/queryClient"
import { queryKeys } from "$lib/query/keys"
let ruta_java = import.meta.env.VITE_RUTA_JAVA_SERVER;
let ruta_local_java = import.meta.env.VITE_RUTA_LOCAL_JAVA_SERVER;
let bd_local = import.meta.env.VITE_LOCAL_BD=="si";
let RUTA_JAVA =bd_local? ruta_local_java:ruta_java
const RUTA_LOTES = "lots"
function processLot(lot) {
    let data_lote = {
        id: lot.lotId,
        nombre: lot.name,
        active: lot.isActive,
        cab: lot.establishmentId,
        total: lot.animalCount,
        latitude: lot.latitude,
        longitude: lot.longitude

    }
    return data_lote
}
function processLots(data, cabid = null) {
    let data_lotes = []
    for (let i = 0; i < data.length; i++) {
        let fila = data[i]
        if (fila.isActive) {
            if (cabid) {
                if (fila.establishmentId == cabid) {
                    
                    data_lotes.push(processLot(fila))
                }

            }
            else {
                data_lotes.push(processLot(fila))
            }

        }

    }
    return data_lotes
}
// Transformacion completa de la respuesta de /lots/all (process + filtro activos).
// Exportada para que el seed del cache (cold-start offline) comparta exactamente
// la misma logica que getAll y nunca diverja.
export function processLotsResponse(data, cabid = null) {
    return processLots(data, cabid).filter((l) => l.active);
}
function isRealError(err) {
    return !!err && (err.message === "SESIÓN_EXPIRADA" || err.message === "SIN_PERMISO" || typeof err.status === "number")
}
export async function getAll(cabid = null) {
    let ruta = `${RUTA_JAVA}${RUTA_LOTES}/all`
    let url = new URL(ruta);
    if (cabid) {
        url.searchParams.append('establishmentId', cabid);
    }
    let user = getUser();
    let token = user.token;
    let options = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        }
    }
    try {
        let res_all = await handleAuthenticatedRequest(url.toString(), options)

        let data_all = await jsonOrThrow(res_all, "lotes.getAll")

        return processLotsResponse(data_all, cabid)
    } catch (err) {
        if (isRealError(err)) throw err
        await cacheRestored
        const cached = cabid ? queryClient.getQueryData(queryKeys.lots(cabid)) : null
        if (Array.isArray(cached)) return cached
        throw err
    }
}
export async function getLotlId(id) {
    let ruta = `${RUTA_JAVA}${RUTA_LOTES}/${id}`
    let user = getUser();
    let token = user.token;
    let options = {
        headers: {

            "Authorization": `Bearer ${token}`
        }
    }
    let res_all = await fetch(ruta, options)
    let data_all = await res_all.json()
    let procesada = processLot(data_all)
    return procesada
}
function postData(data) {
    let data_lot = {
        name: data.nombre,

        establishmentId:data.cab
    }

    return data_lot
}
export async function saveLot(data) {
    let ruta = `${RUTA_JAVA}${RUTA_LOTES}`
    let data_lot = postData(data)
    let user = getUser();
    let token = user.token;

    let res_save = await fetch(ruta, {
        method: "POST",
        body: JSON.stringify(data_lot), // data can be `string` or {object}!
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
    })
    let data_save = await res_save.json()
    if (!res_save.ok) {
        throw new Error(data_save?.message || "No se pudo guardar el lote")
    }
    return data_save
}
export async function editLote(id, data) {
    let ruta = `${RUTA_JAVA}${RUTA_LOTES}/${id}`

    let user = getUser();
    let token = user.token;
    let res_post = await fetch(ruta,
        {
            method: "PUT",
            body: JSON.stringify(data), // data can be `string` or {object}!
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
        }
    )

    let data_post = await res_post.json()
    if (!res_post.ok) {
        throw new Error(data_post?.message || "No se pudo actualizar el lote")
    }
    return data_post
}
export async function eliminarLote(id) {
    let ruta = `${RUTA_JAVA}${RUTA_LOTES}/delete/${id}`
    let user = getUser();
    let token = user.token;
    let res_post = await fetch(ruta,
        {
            method: "POST",
            //            body: JSON.stringify({}), // data can be `string` or {object}!
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
        }
    )

    //let data_post = await res_post.json()
    return {}
}